import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function FinalCTA() {
  return <section className="py-12 md:py-24 px-4 bg-cream text-center" data-id="element-26">
      <div className="max-w-3xl mx-auto" data-id="element-27">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-28">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-navy mb-8" data-id="element-29">
            ¿Lista para recuperar la paz en casa?
          </h2>
          <p className="text-xl text-warm-medium mb-10" data-id="element-30">
            Únete a cientos de madres que ya están viendo a sus hijos
            redescubrir el mundo real.
          </p>

          <CTAButton className="max-w-2xl mx-auto" href="#oferta" data-id="element-31" />

          <div className="mt-8 flex items-center justify-center gap-2 text-sm text-warm-medium" data-id="element-32">
            <span data-id="element-33">🔒 Pago 100% seguro y encriptado</span>
          </div>
        </motion.div>
      </div>
    </section>;
}